var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"home"},[_c('b-container',{staticClass:"marginal"},[_c('h2',[_vm._v("Aide")])])],1)}
var staticRenderFns = []

export { render, staticRenderFns }